<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <button pButton pRipple *ngIf="voltar" label="Voltar" icon="pi pi-arrow-left" 
    class="p-button-secondary" (click)="voltarTela()"></button>
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'relatorioVeiculos.controleProposta.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.controleProposta.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="dataInicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'relatorioVeiculos.controleProposta.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-4">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.controleProposta.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="dataFinal" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'relatorioVeiculos.controleProposta.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-4">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'relatorioVeiculos.controleProposta.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'relatorioVeiculos.controleProposta.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportFullExcel()" style="margin-right: 10px;">
                  <i class="fa fa-download mr-1"></i>Export Full
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <!-- Carga Inicial da tela -->
    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela == true">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div class="loading-container" *ngIf="loading && !cargaTela && (!dados || dados.length === 0)">
      <div class="spinner-holder">
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div class="loading-text">Loading...</div>
    </div>

    <div translate *ngIf="!loading && dados?.length <= 0 && cargaTela == false" class="sem-registros text-muted mt-2">
      {{'rmpv.detalhado.nenhumRegistroExibir'}}
    </div>

    <p-table #dt *ngIf="dados?.length > 0" [value]="dados" dataKey="id" selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
      [paginator]="dados?.length > 10" [rows]="10" [loading]="loading" [columns]="cols" [autoLayout]="true"
      [rowHover]="true" [scrollable]="true"
      currentPageReportTemplate="{{'relatorioVeiculos.controleProposta.mostrandoRegistros' | translate}}"
      [showCurrentPageReport]="true" id="excel-table" [rowsPerPageOptions]="[10,20,30,50,100]"       [globalFilterFields]="['codConcessionaria', 'concessionaria', 'idFabrica',
      'idLead', 'codigoEventoLead', 'descTipoEvento', 'leadDataHora', 'leadCaptacao', 'leadNome', 'leadSobrenome', 'leadEmail', 'leadTelefone', 'leadMensagem', 
      'leadModelo', 'leadVersao', 'leadStatus', 'leadTemperatura', 'leadGerente', 'leadVendedor', 'propostaNum']">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup *ngFor="let col of columns">
          <col [style.width]="col.width">
        </colgroup>
      </ng-template>
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{'relatorioVeiculos.controleProposta.filtroGeral' | translate}}" />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th translate class="text-center" style="background-color:black;color:white;" [pSortableColumn]="col.field">
              {{col.header}}
              <em class="fa fa-sort fa-xs float-right" field="col.field"
                *ngIf="col.field !== 'detalhe' && col.field !== 'remover'"></em>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td class="text-center percentual" *ngFor="let col of columns">
            <div *ngIf="col.field === 'detalhe'">
              <button class="btn btn-ver" (click)="exibirDetalhe(dados)" title="Ver Detalhes">
                <img src="assets/img/detail.png" style="cursor: pointer;" />
              </button>
            </div>
            <div>
              {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field] }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.codEvento'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.codEventoPlaceHolder' | translate"
            formControlName="cod_evento" style="min-width: 100%;" />
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.modeloVeic'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.modeloVeicPlaceHolder' | translate"
            formControlName="modelo_veic" style="min-width: 100%;" />
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.versaoVeic'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.versaoVeicPlaceHolder' | translate"
            formControlName="versao_veic" style="min-width: 100%;" />
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.proposta'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.propostaPlaceHolder' | translate" formControlName="numeroProposta"
            style="min-width: 100%;" />
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoVendido.filtros.status'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.tipoPlaceHolder' | translate }}"
            [options]="statusLead" optionLabel="nome" optionValue="valor" formControlName="status_Lead"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.somenteFabrica'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoEstoque.filtros.vendaPlaceHolder' | translate }}"
            [options]="somenteFab" optionLabel="nome" optionValue="valor" formControlName="somente_fabrica"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.idFabrica'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.idFabricaPlaceHolder' | translate"
            formControlName="id_fabrica" style="min-width: 100%;" />
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.tipoEvento'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.tipoEventoPlaceHolder' | translate"
            formControlName="tipo_evento" style="min-width: 100%;" />
        </div>
      </div>
    </div>
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.leads.filtros.origem'}}
        </div>
        <div class="col col-8">
          <input type="text" class="p-inputtext p-inputtext-sm"
            [placeholder]="'relatorioVeiculos.leads.filtros.origemPlaceHolder' | translate"
            formControlName="origem" style="min-width: 100%;" />
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'relatorioVeiculos.controleProposta.filtrar'}}</button>
  </ng-template>
</p-dialog>

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<app-leads-detalhe [visible]="visible" (fecharModalDetalhe)="retornaFecharModalDetalhe($event)" [leadGrid]="leadGrid"
  [dadosHistorico]="dadosHistorico" [dadosUsadoNaTroca]="dadosUsadoNaTroca">
</app-leads-detalhe>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>